import React from 'react';

import type { IApp } from '../../model/items';
import style from './style.module.scss';

interface IProps {
  app: IApp;
}

const AppCard: React.FC<IProps> = ({ app }) => {
  return (
    <div className={style.appCard}>
      <a target="_blank" className={style.appCardIcon} href={app.linkURL}>
        <img src={app.qrCodeImage} alt="qr-code-image" width={110} height={110} />
        <img src={app.storeImage} alt="store-image" width={110} />
      </a>
      <div className={style.appCardBody}>
        <div className={style.appCardBodyTextWrapper}>{app.title}</div>
        <div className={style.appCardFooter}>
          <a target="_blank" href={app.linkURL} className={style.appCardLink}>
            {app.link}
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppCard;
